import FilterSection from "./filter-section";
import SortSection from "./sort-section";
import Root from "./root";

export const Th = {
    Root,
    FilterSection,
    SortSection,
};
